/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from '@angular/forms/src/directives/checkbox_value_accessor';
import * as import1 from '@angular/core/src/linker/view';
export class Wrapper_CheckboxControlValueAccessor {
  context:import0.CheckboxControlValueAccessor;
  changed:boolean;
  constructor(p0:any,p1:any) {
    this.changed = false;
    this.context = new import0.CheckboxControlValueAccessor(p0,p1);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angular/forms/src/directives/checkbox_value_accessor.ngfactory.ts